import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Text,
  VStack,
  Checkbox,
  CheckboxGroup,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { cqAPI } from "../../lib/Auth";
import _ from "lodash";
import dialogManager from "../DialogManager/DialogManager";
import { useAppContext } from "../../AppContext";
import Swal from 'sweetalert2';

const NotificationSettings = () => {
  const [notificationSettings, setNotificationSettings] = useState({
    preferredChannelsByTopicsMap: {},
    topics: {},
    channels: [],
    business: { name: "" },
    user: {},
    active_plan: {
      features: {},
    },
  });
  const [originalSettings, setOriginalSettings] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  
  async function checkRTPermission(){
    if (window.top.Realtime.isPermissionDeniedExplicitly()) {
      window.top.Realtime.showPermissionDeniedAlert(Swal);
      return false;
    } else if (!window.top.Realtime.hasPermission()) {
      const result = await window.top.Realtime.requestPermissionIfNeeded(Swal);
      if (result !== window.top.Realtime.Status.Granted) {
        window.top.Realtime.showPermissionDeniedAlert(Swal);
        return false;
      }
    }
    return true
  }
  
  const fetchNotificationSettings = async () => {
    const data = await cqAPI.get("/settings/notifications").then((x) => x.data);
    setNotificationSettings(data);
    if (data.requestBrowserPermission){
      await checkRTPermission()
    }
    setOriginalSettings(_.cloneDeep(data));
  };

  useEffect(() => {
    fetchNotificationSettings();
  }, []);

  const handleCheckboxChange = (topicName, newValues) => {
    // Update the preferredChannelsByTopicsMap with new values for the specific topic
    setNotificationSettings((prevSettings) => ({
      ...prevSettings,
      preferredChannelsByTopicsMap: {
        ...prevSettings.preferredChannelsByTopicsMap,
        [topicName]: newValues,
      },
    }));
  };
  
  
  const handleSoundChange = (v)=>{
    setNotificationSettings({
      ...notificationSettings,
      notificationSettings : {
        sound : v.target.checked
      }
    })
  }

  useEffect(() => {
    const changesDetected = !_.isEqual(notificationSettings, originalSettings);
    setHasChanges(changesDetected);
  }, [notificationSettings, originalSettings]);

  const { topics, channels, business, preferredChannelsByTopicsMap } = notificationSettings;
  const bgColor = useColorModeValue("gray.100", "gray.700");

  const saveChanges = async () => {
    const changes = {};
    Object.keys(notificationSettings).forEach((key) => {
      if (!_.isEqual(notificationSettings[key], originalSettings[key])) {
        changes[key] = notificationSettings[key];
      }
    });
    const updated = {
      ...changes.preferredChannelsByTopicsMap? {channels : changes.preferredChannelsByTopicsMap} : {},
      ...changes.notificationSettings? {sound : changes.notificationSettings.sound} : {}
    }
    const shouldAskForDesktopNotificaitonPermission = !!Object.keys(updated?.channels || {}).find(key=>updated.channels[key].indexOf('desktop') != -1);
    
    if (shouldAskForDesktopNotificaitonPermission) {
      if (!await checkRTPermission()){
        return
      }
    }
    const resp = await cqAPI.post('/settings/notifications',updated)
    if (resp.msg) {
      dialogManager.open({
        onDeny: () => {},
        acceptText: "OK",
        body: resp.msg,
        header: "Error",
      });
    }
    if (resp.type == 'ok'){
      fetchNotificationSettings()
    }
  };

  return (
    <Box p={4} overflowY="auto" maxH="100vh" w="100%" align="left">
      <Box textAlign="right" mt={4} paddingBottom="25px">
        <Button colorScheme="blue" isDisabled={!hasChanges} onClick={saveChanges}>
          Save
        </Button>
      </Box>
    {Object.entries(topics).map(([topicName, topic]) => {
      const isEnabled = topic.channels && topic.channels.length > 0;
      if (isEnabled) {
        return (
          <Box key={topicName} mb={4} p={4} bgColor={bgColor} borderRadius="md">
            <Text mb={4}>{topic.title}</Text>
            <CheckboxGroup
              defaultValue={preferredChannelsByTopicsMap[topicName] || []}
              onChange={(newValues) => handleCheckboxChange(topicName, newValues)}
            >
              <VStack align="start">
                {channels.map((channel) =>
                  topic.channels.includes(channel) ? (
                    <Checkbox key={channel} value={channel}>
                      {channel}
                    </Checkbox>
                  ) : null
                )}
              </VStack>
            </CheckboxGroup>
          </Box>
        );
      }
      return null;
    })}
      {Object.keys(topics).length > 0 && (<Box key="desktopNotification" mb={4} p={4} bgColor={bgColor} borderRadius="md">
        <Text mb={4}>Desktop notification</Text>
        <Checkbox isChecked={!!notificationSettings?.notificationSettings?.sound} onChange={(newValues) => handleSoundChange(newValues) }>
          Play a sound
        </Checkbox>
    </Box>)}
    </Box>
  );
};

export default NotificationSettings;
